// ConfigSMS.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Grid, Backdrop, CircularProgress,
    IconButton, Tooltip
} from '@mui/material';
import { Delete, Add } from '@mui/icons-material';
import { UrlApi } from '../../../services/apirest';

export default function ConfigSMS({ open, onClose }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    // 1) Al abrir el modal, cargo la lista
    useEffect(() => {
        if (!open) return;
        (async () => {
            setLoading(true);
            try {
                const { data } = await axios.get(`${UrlApi}/scada/sms-recipients`);
                setItems(data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    // 2) Cambios en inputs
    const handleChange = (idx, field, val) => {
        setItems(cur =>
            cur.map((it, i) =>
                i === idx ? { ...it, [field]: val } : it
            )
        );
    };

    // 3) Agregar una fila vacía
    const handleAdd = () => {
        setItems(cur => [
            ...cur,
            { id: null, nombre: '', telefono: '', activo: 1 }
        ]);
    };

    // 4) Borrar local (y luego en el servidor si ya tiene id)
    const handleDelete = idx => {
        const it = items[idx];
        if (it.id) {
            axios.delete(`${UrlApi}/scada/sms-recipients/${it.id}`)
                .catch(console.error);
        }
        setItems(cur => cur.filter((_, i) => i !== idx));
    };

    // 5) Guardar todos: recorro y hago POST o PUT según si tienen id
    const handleGuardar = async () => {
        setLoading(true);
        try {
            await Promise.all(items.map(it => {
                if (it.id) {
                    return axios.put(
                        `${UrlApi}/scada/sms-recipients/${it.id}`,
                        it,
                        { headers: { 'Content-Type': 'application/json' } }
                    );
                } else {
                    return axios.post(
                        `${UrlApi}/scada/sms-recipients`,
                        it,
                        { headers: { 'Content-Type': 'application/json' } }
                    );
                }
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Configurar destinatarios SMS
                <Tooltip title="Agregar">
                    <IconButton onClick={handleAdd} size="small" sx={{ ml: 1 }}>
                        <Add fontSize="small" />
                    </IconButton>
                </Tooltip>
            </DialogTitle>
            <DialogContent dividers>
                {loading && (
                    <Backdrop open sx={{ color: '#fff', zIndex: t => t.zIndex.drawer + 1 }}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                )}
                <Grid container spacing={2}>
                    {items.map((it, idx) => (
                        <React.Fragment key={idx}>
                            <Grid item xs={5}>
                                <TextField
                                    label="Nombre"
                                    value={it.nombre}
                                    onChange={e => handleChange(idx, 'nombre', e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <TextField
                                    label="Teléfono"
                                    value={it.telefono}
                                    onChange={e => handleChange(idx, 'telefono', e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton onClick={() => handleDelete(idx)} color="error">
                                    <Delete />
                                </IconButton>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleGuardar}>Guardar</Button>
            </DialogActions>
        </Dialog>
    );
}
